import * as React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';

const HyperLinkCell = (cell) => {
    const { data } = cell;

    return (<HyperLinkRenderer value={{ ProductId: cell?.data?.row?.data.ProductId, MovementId: cell?.data?.row?.data.MovementId, MovementLineNo: cell?.data?.row?.data.MovementLineNo, FieldValue: data.value }} colDef={{ headerName: 'Movement' }} link='/movement-enquiry' />);
};

export default HyperLinkCell;
